import { registerBlocks } from "./blocks";
import "./editor.scss";
import {
	addPluginSidebar,
	addShortcutSidebar,
	addToolbarLibraryButton,
	autoRecoverBlocks,
	disableBlocks,
	setSectionDefaultWidth,
	updateBlockAttributes,
	updateBlockCategoryIcon,
} from "./helpers";
import { GlobalStylesProcessor } from "./hooks/useGlobalStyles";
import "./store/styles-store";
import { localized } from "./utils";
import "./helpers/change-editor-logo-url";
new GlobalStylesProcessor(localized.configs["global-styles"]).process();

addShortcutSidebar();
// disable blocks.
disableBlocks();

setSectionDefaultWidth();
addToolbarLibraryButton(); // Add toolbar library button.

// Register blocks.
registerBlocks();

updateBlockAttributes(); // update old attributes.
updateBlockCategoryIcon(); // Update Magazine Blocks category icon.
autoRecoverBlocks(); // Auto recover blocks in widget/customize screen.
addPluginSidebar();
new GlobalStylesProcessor(localized.configs["global-styles"]).process();
